import { Declaration } from 'store/declarations/declaration';

// A declaration without mirrorDetails is the source H1, so it comes first.
const SOURCE_POSITION = 0;

const getPosition = (declaration: Declaration): number => declaration.mirrorDetails?.index ?? SOURCE_POSITION;

export const sortMirroredDeclarations = (declarations: Declaration[]): Declaration[] =>
    [...declarations].sort((first, second) => getPosition(first) - getPosition(second));
